import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";

import { updateContextPostmortemState } from "./WebSocketContext/contextStateSetterhelper";

const PostmortemContext = createContext({});

export const PostmortemContextWrapper = ({ children }) => {
  const [mountCount, setMountCount] = useState(0);
  useEffect(() => {
    setMountCount((prevCount) => prevCount + 1);

    return () => { };
  }, []); // Empty array means this effect runs once on mount and cleanup on unmount

  const [currentPostmortemId, setCurrentPostmortemId] = useState("");

  const [currentPostmortemObject, setCurrentPostmortemObject] = useState({});
  const [collaborators, setCollaborators] = useState([]);
  const [postmortemTeamId, setPostmortemTeamId] = useState(null);
  const [appOptionsAvailable, setAppOptionsAvailable] = useState(false);
  const [postmortemObjectForAuditing, setPostmortemObjectForAuditing] =
    useState({});

  const postmortemReducer = (state, action) => {
    switch (action.type) {
      case "HANDLE EDITOR CHANGE":
        return {
          ...state,
          [action.field]: typeof action.payload === "function" // Support callback functions
            ? action.payload(state[action.field])
            : action.payload,
        };
      default:
        return state;
    }
  };

  const setInitialState = () => {
    let initialEditorState = {
      priority: "",
      postmortemCurrentStatus: {
        currentState: "DRAFT",
      },

      incidentSummaryState: {
        incSummDescription: "",
        preceEventsDescription: "",
        impact: "",
        detectionAndResponseDescription: "",
        mttd: "",
        mttrespond: "",
        mttrepair: "",
        mttrecover: "",
        comments: {
          New: [],
          INPROGRESS: [],
          DONE: [],
        },
        isCustomMttrepair: false,
        changedFields: {
          incSummDescription: false,
          preceEventsDescription: false,
          impact: false,
          detectionAndResponseDescription: false,
          mttd: false,
          mttrespond: false,
          mttrepair: false,
          mttrecover: false,
        },
      },

      // incidentSummaryState: {
      //   incSummDescription: "",
      //   comments: {
      //     New: [],
      //     INPROGRESS: [],
      //     DONE: [],
      //   },
      // },
      // PrecedingEventsState: {
      //   preceEventsDescription: "",
      // },
      // ImpactState: {
      //   impact: ""
      // },
      // DetectionAndResponseState: {
      //   detectionAndResponseDescription:""
      // },

      // MttdState: {
      //   mttd: "",
      // },
      // MTTRespondState: {
      //   mttrespond: "",
      // },
      // MttRepairState: {
      //   mttrepair: "",
      //   isCustomMttrepair: false,
      // },
      // MttRecoverState: {
      //   mttrecover: "",
      // },

      // detectionAndResponseDescription: "",
      // mttd: "",
      // mttrespond: "",
      // mttrepair: "",
      // mttrecover: "",
      // comments: {
      //   New: [],
      //   INPROGRESS: [],
      //   DONE: [],
      // },
      // isCustomMttrepair: false,
      // },
      RecoveryState: {
        recovery: "",
        changedFields: {
          recovery: false,
        },
      },
      portfolio: {
        id: "",
        label: "",
        value: "",
      },
      platform: {
        id: "",
        label: "",
        value: "",
      },
      product: {
        id: "",
        label: "",
        value: "",
      },
      app: {
        id: "",
        label: "",
        value: "",
      },

      application_id: {
        value: "",
      },

      mvcVulnerabilityRelated: [],

      RootCauseIdentificationState: {
        description: "",
        questions: [],
        changedFields: {
          rcidescription: false,
          rciquestions: false,
        },
      },
      RootCauseState: {
        cause: "",
        rootCauseCode: "",
        rootCauseSubCode: "",
        changeRelated: "",
        causedByChangeNumber: "",
        causedByVendor: "",
        images: [],
        comments: { NEW: [], INREVIEW: [], DONE: [] },
        tags: [],
        changedFields: {
          rootCause: false,
          rootCauseCode: false,
          rootCauseSubCode: false,
          tags: false,
        },

      },
      PreventiveAndCorrectiveMeasuresState: {
        pTasks: [],
        jiraTickets: [],
        pTaskPlatformPortfolio: "",
        jiraPlatformPortfolio: "",
        comments: { NEW: [], INREVIEW: [], DONE: [] },
        recommendedActions: [],
        changedFields: {
          pTasks: false,
          jiraTickets: false,
        },
      },
      RecurrenceState: {
        recurrence: "",
        // count: "",
        incidentId: "",
        description: "",
        problemId: "",
        description: "",
        pastReferencesList: [],
        changedFields: {
          recurrence: false,
        },
      },

      images: {
        incidentSummary: {
          summary: [],
          precedingEvents: [],
          impact: [],
          detectionAndResponse: [],
        },
        rootCause: {
          rootCause: [],
          rootCauseIdentification: [],
        },
        preventiveCorrectiveMeasures: {
          jira: [],
          ptask: [],
        },
      },

      uploadedImages: {
        summary: [],
        precedingEvents: [],
        impact: [],
        detectionAndResponse: [],
        rootCause: [],
        rootCauseIdentification: [],
        jira: [],
        ptask: [],
      },

      imageFormData: {
        summary: new FormData(),
        precedingEvents: new FormData(),
        impact: new FormData(),
        detectionAndResponse: new FormData(),
        rootCause: new FormData(),
        rootCauseIdentification: new FormData(),
        jira: new FormData(),
        ptask: new FormData(),
      },
      postmortemIsIncompleteState: {
        incomplete: false,
      },

      changedFileds: {
        incSummDescription: false,
        preceEventsDescription: false,
        impact: false,
        detectionAndResponseDescription: false,
        mttd: false,
        mttrespond: false,
        mttrepair: false,
        mttrecover: false,
        rcidescription: false,
        rciquestions: false,
        recurrence: false,
        cause: false,
        pTasks: false,
        jiraTickets: false,
        recovery: false,
        rootCauseCode: false,
        rootCauseSubCode: false,
        tags: false,
        incidentId: false,
        problemId: false,
        vendorDetails: false,

        impactedByChange: false,
        recurringIssue: false,

        portfolio: false,
        platform: false,
        product: false,
        app: false,
      },
      lockedFields: [],
      lockCurrentFields: {
        incident_summary: false,
      },
      recommendedKPIs: {
        mttd: "",
        mttrepair: "",
      },
    };

    return initialEditorState;
  };

  const [postmortemState, dispatch] = useReducer(
    postmortemReducer,
    setInitialState()
  );

  const [originalPostmortemState, setOriginalPostmortemState] = useState(() =>
    setInitialState()
  );

  const memoizedDispatch = useCallback(
    (action) => {
      dispatch(action);
    },
    [dispatch]
  );

  // Function to reset changedFileds for a specific step after successful API submission
  const resetChangedFieldsForStep = useCallback(
    (step) => {
      if (step === 0) {
        // Reset incident summary related fields (Step 0)
        const updatedChangedFileds = {
          ...postmortemState.incidentSummaryState.changedFields,
        };
        updatedChangedFileds.incSummDescription = false;
        updatedChangedFileds.preceEventsDescription = false;
        updatedChangedFileds.impact = false;
        updatedChangedFileds.detectionAndResponseDescription = false;
        updatedChangedFileds.mttd = false;
        updatedChangedFileds.mttrespond = false;
        updatedChangedFileds.mttrepair = false;
        updatedChangedFileds.mttrecover = false;
        memoizedDispatch({
          type: "HANDLE EDITOR CHANGE",
          filed: "incidentSummaryState",
          payload: {
            ...postmortemState.incidentSummaryState,
            changedFields: updatedChangedFileds,
          },
        });
        memoizedDispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "changedFileds",
          payload: (prev) => ({ ...prev, portfolio: false, platform: false, product: false, app: false }),
        });
      } else if (step === 1) {
        // Reset step 1 related fields

        const updatedrootCauseChangedFileds = {
          ...postmortemState.RootCauseState.changedFileds,
        };
        const updatedRciChangedFileds = {
          ...postmortemState.RootCauseIdentificationState.changedFields,
        };
        const updateRecurreceChangedFileds = {
          ...postmortemState.RecurrenceState.changedFields,
        };
        const updateRecoveryChangedFileds = {
          ...postmortemState.RecoveryState.changedFields,
        };

        updatedrootCauseChangedFileds.rootCause = false;
        updatedrootCauseChangedFileds.rootCauseCode = false;
        updatedrootCauseChangedFileds.rootCauseSubCode = false;
        updatedrootCauseChangedFileds.tags = false;
        updatedrootCauseChangedFileds.causedByChangeNumber = false;
        updatedrootCauseChangedFileds.causedByVendor = false;
        updatedrootCauseChangedFileds.changeRelated = false;
        updateRecoveryChangedFileds.recovery = false;

        updatedRciChangedFileds.rcidescription = false;
        updatedRciChangedFileds.rciquestions = false;
        updateRecurreceChangedFileds.recurrence = false;

        memoizedDispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "RootCauseState",
          payload: {
            ...postmortemState.RootCauseState,
            changedFields: updatedrootCauseChangedFileds,
          },
        });
        memoizedDispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "RootCauseIdentificationState",
          payload: {
            ...postmortemState.RootCauseIdentificationState,
            changedFields: updatedRciChangedFileds,
          },
        });
        memoizedDispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "RecurrenceState",
          payload: {
            ...postmortemState.RecurrenceState,
            changedFields: updateRecurreceChangedFileds,
          },
        });
        memoizedDispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "RecoveryState",
          payload: {
            ...postmortemState.RecoveryState,
            changedFields: updateRecoveryChangedFileds,
          },
        });

        //   updatedChangedFileds.recovery = false;
        //   updatedChangedFileds.rcidescription = false;
        //   updatedChangedFileds.rciquestions = false;
        //   updatedChangedFileds.rootCause = false;
        //   updatedChangedFileds.rootCauseCode = false;
        //   updatedChangedFileds.rootCauseSubCode = false;
        //   updatedChangedFileds.tags = false;
        //   updatedChangedFileds.recurrence = false;
        // } else if (step === 2) {
        // Reset step 2 related fields
        // updatedChangedFileds.pTasks = false;
        // updatedChangedFileds.jiraTickets = false;
      } else {
        const updatedPCMChangedFileds = {
          ...postmortemState.PreventiveAndCorrectiveMeasuresState.changedFields,
        };
        updatedPCMChangedFileds.pTasks = false;
        updatedPCMChangedFileds.jiraTickets = false;
        memoizedDispatch({
          type: "HANDLE EDITOR CHANGE",
          field: "PreventiveAndCorrectiveMeasuresState",
          payload: {
            ...postmortemState.PreventiveAndCorrectiveMeasuresState,
            changedFields: updatedPCMChangedFileds,
          },
        });
      }

      // Update the changedFileds object
      // memoizedDispatch({
      //   type: "HANDLE EDITOR CHANGE",
      //   field: "changedFileds",
      //   payload: updatedChangedFileds,
      // });
    },
    [
      memoizedDispatch,
      postmortemState.changedFileds,
      postmortemState.incidentSummaryState,
      postmortemState.RootCauseState,
      postmortemState.RootCauseIdentificationState,
      postmortemState.RecurrenceState,
      postmortemState.RecoveryState,
      postmortemState.PreventiveAndCorrectiveMeasuresState,
    ]
  );

  useEffect(() => {
    if (
      currentPostmortemObject &&
      Object.keys(currentPostmortemObject).length !== 0
    ) {
      // Skip full context re-dispatch for auto-save updates.
      // Auto-saves are partial (only changed fields) and the context state is
      // already correct from the dispatch in onSave. Re-dispatching from a
      // partially-updated currentPostmortemObject would wipe out fields like
      // rootCauseCode or mttd that weren't included in the partial save.
      if (currentPostmortemObject.__autoSave) {
        return;
      }
      updateContextPostmortemState(
        currentPostmortemObject,
        memoizedDispatch,
        setOriginalPostmortemState
      );
      updateContextForMacData(currentPostmortemObject);
    }
  }, [currentPostmortemObject]);

  const updateContextForMacData = (currentPostmortemObject) => {
    memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "postmortemIsIncompleteState",
      payload: {
        incomplete: currentPostmortemObject.postMortemIncomplete || false,
      },
    });

    memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "priority",
      payload: currentPostmortemObject.priority,
    });

    memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "portfolio",
      payload: {
        id: currentPostmortemObject.portfolio
          ? currentPostmortemObject.portfolio
          : "",
        label: currentPostmortemObject.portfolio
          ? currentPostmortemObject.portfolio
          : "",
        value: currentPostmortemObject.portfolio
          ? currentPostmortemObject.portfolio
          : "",
      },
    });

    memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "platform",
      payload: {
        id: currentPostmortemObject.platform
          ? currentPostmortemObject.platform
          : "",
        label: currentPostmortemObject.platform
          ? currentPostmortemObject.platform
          : "",
        value: currentPostmortemObject.platform
          ? currentPostmortemObject.platform
          : "",
      },
    });

    memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "product",
      payload: {
        id: currentPostmortemObject.product
          ? currentPostmortemObject.product
          : "",
        label: currentPostmortemObject.product
          ? currentPostmortemObject.product
          : "",
        value: currentPostmortemObject.product
          ? currentPostmortemObject.product
          : "",
      },
    });

    memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "app",
      payload: {
        id: currentPostmortemObject.application
          ? currentPostmortemObject.application
          : "",
        label: currentPostmortemObject.application
          ? currentPostmortemObject.application
          : "",
        value: currentPostmortemObject.application
          ? currentPostmortemObject.application
          : "",
      },
    });

    memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "application_id",
      payload: {
        value: currentPostmortemObject.application_id
          ? currentPostmortemObject.application_id
          : "",
      },
    });

    memoizedDispatch({
      type: "HANDLE EDITOR CHANGE",
      field: "mvcVulnerabilityRelated",
      payload: currentPostmortemObject.mvcVulnerabilityRelated || [],
    });

    setOriginalPostmortemState((currState) => {
      return {
        ...currState,
        portfolio: {
          id: currentPostmortemObject.portfolio
            ? currentPostmortemObject.portfolio
            : "",
          label: currentPostmortemObject.portfolio
            ? currentPostmortemObject.portfolio
            : "",
          value: currentPostmortemObject.portfolio
            ? currentPostmortemObject.portfolio
            : "",
        },
        platform: {
          id: currentPostmortemObject.platform
            ? currentPostmortemObject.platform
            : "",
          label: currentPostmortemObject.platform
            ? currentPostmortemObject.platform
            : "",
          value: currentPostmortemObject.platform
            ? currentPostmortemObject.platform
            : "",
        },
        product: {
          id: currentPostmortemObject.product
            ? currentPostmortemObject.product
            : "",
          label: currentPostmortemObject.product
            ? currentPostmortemObject.product
            : "",
          value: currentPostmortemObject.product
            ? currentPostmortemObject.product
            : "",
        },
        app: {
          id: currentPostmortemObject.application
            ? currentPostmortemObject.application
            : "",
          label: currentPostmortemObject.application
            ? currentPostmortemObject.application
            : "",
          value: currentPostmortemObject.application
            ? currentPostmortemObject.application
            : "",
        },

        application_id: {
          value: currentPostmortemObject.application_id
            ? currentPostmortemObject.application_id
            : "",
        },

        mvcVulnerabilityRelated: currentPostmortemObject.mvcVulnerabilityRelated || [],
      };
    });
  };

  return (
    <PostmortemContext.Provider
      value={{
        currentPostmortemId,
        setCurrentPostmortemId,
        postmortemState,
        memoizedDispatch,
        currentPostmortemObject,
        setCurrentPostmortemObject,
        setPostmortemTeamId,
        setCollaborators,
        postmortemTeamId,
        collaborators,
        appOptionsAvailable,
        setAppOptionsAvailable,
        updateContextPostmortemState,
        postmortemObjectForAuditing,
        setPostmortemObjectForAuditing,
        resetChangedFieldsForStep, // Expose the reset function
      }}
    >
      {children}
    </PostmortemContext.Provider>
  );
};

export default function UsePostmortemInfo() {
  return useContext(PostmortemContext);
}

// export default PostmortemContext
